import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "logoContainer", "logoText", "navText", "collapseIcon", "panel", "overlay"]
  static values = {
    collapsed: { type: String, default: "w-20" },
    expanded: { type: String, default: "w-64" },
    activeSubmenu: { type: String, default: "" },
    mobileBreakpoint: { type: Number, default: 768 }
  }

  connect() {
    this.handleResize() // Initialiser la sidebar en mode mobile/desktop
    window.addEventListener("resize", this.handleResize.bind(this))

    // Initialiser l'icône de collapse
    this.updateCollapseIcon()
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize.bind(this))
  }

  handleResize() {
    if (window.innerWidth < this.mobileBreakpointValue) {
      this.menuTarget.classList.add("hidden")
      if (this.hasOverlayTarget) {
        this.overlayTarget.classList.add("hidden")
      }

      // Mobile positioning
      this.menuTarget.classList.add("absolute", "z-50")
      this.menuTarget.classList.remove("relative", "z-0")
    } else {
      this.menuTarget.classList.remove("hidden")
      if (this.hasOverlayTarget) {
        this.overlayTarget.classList.add("hidden") // Ensure overlay is hidden on desktop
      }

      // Desktop positioning
      this.menuTarget.classList.remove("absolute", "z-50")
      this.menuTarget.classList.add("relative", "z-0")
    }
  }

  toggle() {
    if (window.innerWidth < this.mobileBreakpointValue) {
      // Mobile: toggle sidebar and overlay
      this.menuTarget.classList.toggle("hidden")
      if (this.hasOverlayTarget) {
        this.overlayTarget.classList.toggle("hidden")
      }
    } else {
      const isCollapsed = this.menuTarget.classList.contains(this.collapsedValue)

      // Remove both collapsed and expanded classes first
      this.menuTarget.classList.remove(this.collapsedValue, this.expandedValue)

      // Add the appropriate class based on current state
      if (isCollapsed) {
        this.menuTarget.classList.add(this.expandedValue)
      } else {
        this.menuTarget.classList.add(this.collapsedValue)
      }

      // Mettre à jour l'affichage des textes
      this.navTextTargets.forEach(text => text.classList.toggle("hidden"))
      this.logoTextTarget.classList.toggle("hidden")
      this.logoContainerTarget.classList.toggle("justify-center")

      // If we're collapsing the sidebar and a submenu is open, close it
      if (!isCollapsed && this.activeSubmenuValue) {
        const activeSubmenu = document.getElementById(this.activeSubmenuValue)
        const activeSubmenuIcon = document.querySelector(`[data-submenu-icon="${this.activeSubmenuValue}"]`)
        if (activeSubmenu) {
          activeSubmenu.classList.add("hidden")
          activeSubmenuIcon.classList.remove("fa-chevron-down")
          activeSubmenuIcon.classList.add("fa-chevron-right")
        }
        this.activeSubmenuValue = ""
      }

      // Mettre à jour l'icône
      this.updateCollapseIcon()
    }

    // Dispatch event for other components to react
    document.dispatchEvent(new CustomEvent("sidebar:toggled"))
  }

  toggleAccont() {
    this.panelTarget.classList.toggle("hidden")
  }

  toggleSubmenu(event) {
    const submenuId = event.currentTarget.dataset.submenuId
    const submenu = document.getElementById(submenuId)
    const submenuIcon = document.querySelector(`[data-submenu-icon="${submenuId}"]`)

    // If this is the active submenu, just toggle it
    if (this.activeSubmenuValue === submenuId) {
      submenu.classList.toggle("hidden")

      // Toggle between right and down arrow
      if (submenu.classList.contains("hidden")) {
        submenuIcon.classList.remove("fa-chevron-down")
        submenuIcon.classList.add("fa-chevron-right")
      } else {
        submenuIcon.classList.remove("fa-chevron-right")
        submenuIcon.classList.add("fa-chevron-down")
      }

      this.activeSubmenuValue = submenu.classList.contains("hidden") ? "" : submenuId
    } else {
      // If there's another active submenu, close it first
      if (this.activeSubmenuValue) {
        const activeSubmenu = document.getElementById(this.activeSubmenuValue)
        const activeSubmenuIcon = document.querySelector(`[data-submenu-icon="${this.activeSubmenuValue}"]`)
        if (activeSubmenu) {
          activeSubmenu.classList.add("hidden")
          activeSubmenuIcon.classList.remove("fa-chevron-down")
          activeSubmenuIcon.classList.add("fa-chevron-right")
        }
      }

      // Open the new submenu
      submenu.classList.remove("hidden")
      submenuIcon.classList.remove("fa-chevron-right")
      submenuIcon.classList.add("fa-chevron-down")
      this.activeSubmenuValue = submenuId
    }
  }

  updateCollapseIcon() {
    const isCollapsed = this.menuTarget.classList.contains(this.collapsedValue)
    this.collapseIconTarget.classList.toggle("fa-chevron-left", !isCollapsed)
    this.collapseIconTarget.classList.toggle("fa-chevron-right", isCollapsed)
  }
}
